import {Component, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {FileReference} from '../../../class/file-reference';
import {Util} from '../../../util/util';

@Component({
  selector: 'app-usege-condition-dialog',
  templateUrl: './usege-condition-dialog.component.html',
  styleUrls: ['./usege-condition-dialog.component.css']
})
export class UsegeConditionDialogComponent extends BaseDialog<boolean> implements OnInit {

  options = [
    {value: true, label: 'Accetto i termini del contratto di licenza', checked: false},
    {value: false, label: 'Non accetto i termini del contratto di licenza', checked: true},
  ];
  selectedOption;

  constructor(dialogRef: NbDialogRef<boolean>, route: Router) {
    super(dialogRef, route);
  }

  get pdfUrl() {
    return 'https://prospettivawefare-public.s3-eu-west-1.amazonaws.com/resources/LICENZA_WELFY_ONLINE.pdf';
  }

  ngOnInit() {
  }

  isDisabled() {
    let ret = true;

    if (this.selectedOption) {
      const selectedValue = this.selectedOption;
      ret = selectedValue === this.options[1].value;
    }

    return ret;
  }

}
